import React from 'react';
import { Brodcrumb } from '../components/ui/UtilsLayout';
import { iconsPath, imagePath } from '../utils/imagePath';

// CaseStudy Component
const CaseStudy = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <div className="absolute top-0 left-0 right-0 h-[430px] md:h-[600px] bg-[#222429] rounded-b-[30px] md:rounded-b-[40px] lg:rounded-b-[100px] z-0"></div>

      <div className="max-w-7xl w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'Monorail Simulator-Monorail Simulator',
            item: [
              { name: 'Automotive & Transportation', path: -2 },
              { name: 'Industry Use Cases', path: -1 },
            ],
          }}
        />

        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="h-[100px] w-[100px] bg-[#31333A] rounded-[10px] p-2 flex justify-center items-center shadow-md">
              {/* Company Logo */}
              {imagePath?.medhaLogo ? (
                <img src={imagePath.medhaLogo} alt="Medha Logo" />
              ) : (
                <span className="text-gray-400">No Logo</span>
              )}
            </div>

            {/* Case Study Heading */}
            <div className="flex flex-col gap-5 justify-center">
              <CaseStudyHeading
                title="Case Study title mentioned over here"
                desc="Subtitle mentioned over here to boot."
              />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] rounded-[10px] flex justify-center items-center shadow-xl">
              {/* Play Icon */}
              {iconsPath?.PlayIcon && (
                <img
                  src={iconsPath.PlayIcon}
                  alt="Play Video"
                  className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 cursor-pointer hover:scale-110 transition-transform"
                />
              )}

              {/* QR Code in Top-Right Corner */}
              {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="Case Study title mentioned over here"
            content="It is a long established fact that a reader will be distracted..."
          />

          <Section
            title="Another Section"
            content="Various versions have evolved over the years, sometimes by accident..."
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <CaseStudyHeading
              title="Images and Insights"
              desc="Subtitle mentioned over here to boot."
            />
            <div className="flex flex-col gap-3">
              <div className="flex md:flex-row flex-col gap-20 w-full">
                <ImageCard
                  image={imagePath?.americana1}
                  title="AR Experience Interface"
                />
                <ImageCard
                  image={imagePath?.americanaImage2}
                  title="Interactive Product Display"
                />
              </div>
            </div>
          </div>

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <CaseStudyHeading title="Impact" />
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-5 lg:gap-10">
              {[
                { percentage: '60%', description: 'Reduction in error rates' },
                { percentage: '75%', description: 'Increase in efficiency' },
                { percentage: '90%', description: 'Enhanced productivity' },
              ].map((impact, i) => (
                <ImpactCard
                  key={i}
                  percentage={impact.percentage}
                  description={impact.description}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// 🔹 Reusable Case Study Heading Component
const CaseStudyHeading = React.memo(({ title, desc }) => (
  <>
    {title && (
      <h2 className="text-left font-bold text-xl md:text-2xl text-[#D8D8D8]">
        {title}
      </h2>
    )}
    {desc && (
      <p className="text-[#fff] max-w-[630px] text-[16px] md:text-[20px]">
        {desc}
      </p>
    )}
  </>
));

// 🔹 Reusable Section Component
const Section = ({ title, content }) => (
  <div className="flex flex-col gap-3">
    <CaseStudyHeading title={title} />
    <p className="text-[#C8C8C8]">{content}</p>
  </div>
);

// 🔹 Reusable Image Card Component
const ImageCard = ({ image, title }) => (
  <div className="flex-1 w-full flex flex-col gap-3">
    <div className="w-full h-[500px] bg-[#31333A] rounded-[10px] shadow-md overflow-hidden">
      {image ? (
        <img
          src={image}
          alt={title || 'Case study image'}
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-gray-500">
          No Image Available
        </div>
      )}
    </div>
    <div className="w-full text-center text-[#949494]">
      {title || 'Title of the image goes over here'}
    </div>
  </div>
);

// 🔹 Reusable Impact Card Component
const ImpactCard = ({ percentage, description }) => (
  <div className="rounded-[10px] p-4 h-[150px] md:h-[240px] w-full bg-[#232428] flex flex-col gap-2 justify-center items-center shadow-md">
    <div className="text-[30px] md:text-[40px] lg:text-[50px] text-center">
      {percentage}
    </div>
    <div className="text-[16px] md:text-[20px] lg:text-[25px] text-center">
      {description}
    </div>
  </div>
);

export default CaseStudy;
